webpackJsonp([40],{

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_app_actions_app_actions__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_accountant_step_question__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function created() {
	this.$currentSubsidiary({});
}
function backStep() {
	this.step -= 1;
}

function closeDialog() {
	this.openDialog = false;
}

function runAction(_ref) {
	var codeWeb = _ref.codeWeb;

	this.goTo(codeWeb);
}
function nextStep(finish) {
	if (finish) {
		this.savePlan();
	} else {
		this.step += 1;
	}
}
function followingQuestion() {
	this.goTo('statistics');
}

function data() {
	return {
		step: 1,
		openDialog: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'main',
	created: created,
	components: {
		appActions: __WEBPACK_IMPORTED_MODULE_1__components_shared_app_actions_app_actions__["a" /* default */],
		stepQuestion: __WEBPACK_IMPORTED_MODULE_2__components_accountant_step_question__["a" /* default */],
		closeDialog: closeDialog
	},
	data: data,
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('subsidiary', {
		$currentSubsidiary: 'setCurrentSubsidiary'
	}), {
		nextStep: nextStep,
		runAction: runAction,
		backStep: backStep,
		followingQuestion: followingQuestion
	})
});

/***/ }),

/***/ 1179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(20);




var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var dataUserInfo, params, _$route$params, subsidiaryId, subsidiaryName, id, currentSubsidiary, _currentSubsidiary;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
						params = {
							customerId: dataUserInfo ? dataUserInfo.subsidiary.customerId : null
						};
						_context.next = 4;
						return this.$loadSubsidiaries({ context: this, params: params });

					case 4:
						_$route$params = this.$route.params, subsidiaryId = _$route$params.subsidiaryId, subsidiaryName = _$route$params.subsidiaryName;

						if (subsidiaryId && subsidiaryName) {
							id = Number(subsidiaryId);
							currentSubsidiary = this.getGlobalSubsidiaries.find(function (sub) {
								return sub.id === id;
							});

							this.$setCurrentSubsidiary(currentSubsidiary);
						} else if (this.getGlobalSubsidiaries.length === 1) {
							_currentSubsidiary = this.getGlobalSubsidiaries.find(function (sub) {
								return sub.companyId != null;
							});

							this.$setCurrentSubsidiary(_currentSubsidiary);
						}

					case 6:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function disabledQuestion() {
	return this.showOne && !this.currentSubsidiary.id;
}

function open(propTrue, propFalse) {
	this[propTrue] = true;
	this[propFalse] = false;
}

function data() {
	return {
		showOne: true,
		showTwo: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'step-question',
	components: {
		HeaderSelect: function HeaderSelect() {
			return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 722));
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		disabledQuestion: disabledQuestion
	}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('user', ['userAvatar', 'userName']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])('subsidiary', ['currentSubsidiary', 'getGlobalSubsidiaries'])),
	created: created,
	data: data,
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		open: open
	}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', {
		$clearUser: 'clearUser'
	}), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('subsidiary', {
		$setCurrentSubsidiary: 'setCurrentSubsidiary',
		$loadSubsidiaries: 'loadSubsidiaries'
	})),
	props: {
		acceptDescription: {
			default: 'La contabilidad es una disciplina que se encarga de estudiar, medir y analizar el patrimonio y la situación económica financiera de una empresa u organización, con el fin de facilitar la toma de decisiones en el seno de la misma y el control externo, presentando la información, previamente registrada, de manera sistemática y útil para las distintas partes interesadas.',
			type: String
		},
		acceptTitle: {
			default: 'INTEGRATE CON MAKIPOS',
			type: String
		},
		negativeTitle: {
			default: 'YO LLEVO MI CONTABILIDAD',
			type: String
		},
		openDialog: {
			default: false,
			type: Boolean
		},
		question: {
			default: 'BIENVENIDO AL SISTEMA CONTABLE<br/>MAKIPOS!',
			type: String
		},
		subsidiaryId: [Number, String],
		validIntegration: {
			default: true,
			type: Boolean
		}
	}
});

/***/ }),

/***/ 1442:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1443);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("1ff730d0", content, true, {});

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.slider-list[data-v-4223af12]{font-family:AvenirRegular!important;font-size:11px!important;padding-left:38px;padding-right:28px}@media(max-width:768px){.slider-list[data-v-4223af12]{padding-left:10px;padding-right:10px}}.sliderDinamic[data-v-4223af12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.sliderDinamic .clients[data-v-4223af12]{font-size:16px}.sliderDinamic .clients[data-v-4223af12],.sliderDinamic .titleModule[data-v-4223af12]{width:64px;height:21px;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-family:DMSans;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;text-align:left;color:#06152b}.sliderDinamic .titleModule[data-v-4223af12]{font-size:20px}.accountant-steps .stepper__header[data-v-4223af12]{border-bottom:3px solid;border-top:3px solid;-webkit-box-shadow:none;box-shadow:none;height:56px}.accountant-steps .stepper__header-start[data-v-4223af12],.accountant-steps .stepper__header[data-v-4223af12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.accountant-steps .stepper__header-height[data-v-4223af12]{border-bottom:0;height:40px}.accountant-steps .stepper__header.stepper-header-container[data-v-4223af12]{background-color:transparent;border:0;height:auto;margin:0 auto;width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}@media(min-width:900px){.accountant-steps .stepper__header.stepper-header-container[data-v-4223af12]{max-width:848px}}.accountant-steps .stepper__header.stepper-header-container .stepper__step[data-v-4223af12]{padding:0 8px}.accountant-steps .stepper__header.stepper-header-container .stepper__step__step[data-v-4223af12]{border:0;-webkit-box-shadow:0 1px 4px 0 hsla(0,0%,58%,.5);box-shadow:0 1px 4px 0 hsla(0,0%,58%,.5);display:none}.accountant-steps .stepper__header.stepper-header-container .stepper__label[data-v-4223af12]{color:#9ca6b0!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;font-family:Opens_semibold;font-size:12px;text-shadow:none!important}.accountant-steps .stepper__header.stepper-header-container .divider[data-v-4223af12]{background:#d2d2d2!important;height:2px;margin:0;max-width:36px}.accountant-steps .stepper__header.stepper-header-container .stepper__label[data-v-4223af12]{color:#d2d2d2!important}.accountant-steps .stepper__header.stepper-header-container .stepper__step--complete .stepper__step__step[data-v-4223af12]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;background-color:!important;margin-right:8px!important}.accountant-steps .stepper__header.stepper-header-container .stepper__step--complete .stepper__label[data-v-4223af12]{color:!important;font-family:Opens_bold}.accountant-steps .stepper__header.stepper-header-container .stepper__step--complete+.divider[data-v-4223af12]{background:#e0e5e8!important}.accountant-steps .stepper__header.stepper-header-container .stepper__step--active .stepper__label[data-v-4223af12]{color:#e0e5e8!important;font-family:Opens_bold}.accountant-steps .stepper__header.stepper-header-container .stepper__step--active.stepper__step--active-border[data-v-4223af12]{border-bottom:4px solid #e0e5e8!important}.accountant-steps .stepper__content[data-v-4223af12]{min-height:calc(100vh - 148px);padding:0}.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__container[data-v-4223af12]{color:#d2d2d2!important}.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__toggle[data-v-4223af12]{background-color:transparent!important;border:1px solid currentColor!important;height:15px!important;width:35px!important}.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__ripple[data-v-4223af12]{color:#d2d2d2!important}.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__ripple[data-v-4223af12]:after{background-color:currentColor!important;-webkit-box-shadow:none!important;box-shadow:none!important;height:15px!important;width:18px!important}.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch.input-group--dirty.success--text .input-group--selection-controls__container[data-v-4223af12],.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch.input-group--dirty.success--text .input-group--selection-controls__ripple[data-v-4223af12]{color:!important}", "", {"version":3,"sources":["/opt/build/repo/src/pages/main/page-main.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,8BAA8B,oCAAuC,yBAA0B,kBAAkB,kBAAkB,CAClI,AACD,wBACA,8BAA8B,kBAAkB,kBAAkB,CACjE,CACA,AACD,gCAAgC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,6BAA6B,CAClO,AACD,yCAAsI,cAAe,CACpJ,AACD,sFAFyC,WAAW,YAAY,mBAAmB,oBAAoB,YAAY,mBAAmB,AAAe,gBAAiB,oBAAoB,kBAAkB,mBAAmB,sBAAsB,gBAAgB,aAAa,CAGjR,AADD,6CAA0I,cAAe,CACxJ,AACD,oDAAoD,wBAAwB,qBAAqB,wBAAwB,gBAAgB,WAAY,CACpJ,AACD,8GAFqJ,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,wBAAwB,qBAAqB,sBAAsB,CAGhX,AACD,2DAA2D,gBAAkB,WAAW,CACvF,AACD,6EAA6E,6BAA+B,SAAW,YAAY,cAAgB,WAAW,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,6BAA6B,CAChW,AACD,wBACA,6EAA6E,eAAe,CAC3F,CACA,AACD,4FAA4F,aAAe,CAC1G,AACD,kGAAkG,SAAW,iDAAoD,yCAA4C,YAAY,CACxN,AACD,6FAA6F,wBAAyB,8BAA+B,8BAA+B,uBAAwB,2BAA6B,eAAe,0BAA2B,CAClR,AACD,sFAAsF,6BAA8B,WAAW,SAAW,cAAc,CACvJ,AACD,6FAA6F,uBAAwB,CACpH,AACD,2HAA2H,2BAA2B,2BAA2B,oBAAoB,4BAA4B,0BAA2B,CAC3P,AACD,sHAAsH,iBAAiB,sBAAwB,CAC9J,AACD,+GAA+G,4BAA6B,CAC3I,AACD,oHAAoH,wBAAyB,sBAAwB,CACpK,AACD,iIAAiI,yCAA0C,CAC1K,AACD,qDAAqD,+BAA+B,SAAW,CAC9F,AACD,qJAAqJ,uBAAwB,CAC5K,AACD,kJAAkJ,uCAA0C,wCAAyC,sBAAuB,oBAAqB,CAChR,AACD,kJAAkJ,uBAAwB,CACzK,AACD,wJAAwJ,wCAAyC,kCAAmC,0BAA2B,sBAAuB,oBAAqB,CAC1S,AACD,yWAAyW,gBAAgB,CACxX","file":"page-main.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.slider-list[data-v-4223af12]{font-family:\"AvenirRegular\" !important;font-size:11px !important;padding-left:38px;padding-right:28px\n}\n@media(max-width: 768px){\n.slider-list[data-v-4223af12]{padding-left:10px;padding-right:10px\n}\n}\n.sliderDinamic[data-v-4223af12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.sliderDinamic .clients[data-v-4223af12]{width:64px;height:21px;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-family:DMSans;font-size:16px;font-weight:bold;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;text-align:left;color:#06152b\n}\n.sliderDinamic .titleModule[data-v-4223af12]{width:64px;height:21px;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;font-family:DMSans;font-size:20px;font-weight:bold;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;text-align:left;color:#06152b\n}\n.accountant-steps .stepper__header[data-v-4223af12]{border-bottom:3px solid;border-top:3px solid;-webkit-box-shadow:none;box-shadow:none;height:56px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.accountant-steps .stepper__header-start[data-v-4223af12]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.accountant-steps .stepper__header-height[data-v-4223af12]{border-bottom:0px;height:40px\n}\n.accountant-steps .stepper__header.stepper-header-container[data-v-4223af12]{background-color:rgba(0,0,0,0);border:0px;height:auto;margin:0px auto;width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n@media(min-width: 900px){\n.accountant-steps .stepper__header.stepper-header-container[data-v-4223af12]{max-width:848px\n}\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step[data-v-4223af12]{padding:0px 8px\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step__step[data-v-4223af12]{border:0px;-webkit-box-shadow:0 1px 4px 0 rgba(148,148,148,.5);box-shadow:0 1px 4px 0 rgba(148,148,148,.5);display:none\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__label[data-v-4223af12]{color:#9ca6b0 !important;display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;font-family:\"Opens_semibold\";font-size:12px;text-shadow:none !important\n}\n.accountant-steps .stepper__header.stepper-header-container .divider[data-v-4223af12]{background:#d2d2d2 !important;height:2px;margin:0px;max-width:36px\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__label[data-v-4223af12]{color:#d2d2d2 !important\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step--complete .stepper__step__step[data-v-4223af12]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;background-color:!important;margin-right:8px !important\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step--complete .stepper__label[data-v-4223af12]{color:!important;font-family:\"Opens_bold\"\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step--complete+.divider[data-v-4223af12]{background:#e0e5e8 !important\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step--active .stepper__label[data-v-4223af12]{color:#e0e5e8 !important;font-family:\"Opens_bold\"\n}\n.accountant-steps .stepper__header.stepper-header-container .stepper__step--active.stepper__step--active-border[data-v-4223af12]{border-bottom:4px solid #e0e5e8 !important\n}\n.accountant-steps .stepper__content[data-v-4223af12]{min-height:calc(100vh - 148px);padding:0px\n}\n.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__container[data-v-4223af12]{color:#d2d2d2 !important\n}\n.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__toggle[data-v-4223af12]{background-color:rgba(0,0,0,0) !important;border:1px solid currentColor !important;height:15px !important;width:35px !important\n}\n.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__ripple[data-v-4223af12]{color:#d2d2d2 !important\n}\n.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch .input-group--selection-controls__ripple[data-v-4223af12]:after{background-color:currentColor !important;-webkit-box-shadow:none !important;box-shadow:none !important;height:15px !important;width:18px !important\n}\n.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch.input-group--dirty.success--text .input-group--selection-controls__container[data-v-4223af12],.accountant-steps .accountant-switch.input-group.input-group--selection-controls.switch.input-group--dirty.success--text .input-group--selection-controls__ripple[data-v-4223af12]{color:!important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_question_vue__ = __webpack_require__(1179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41b7c46d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_step_question_vue__ = __webpack_require__(1450);
function injectStyle (ssrContext) {
  __webpack_require__(1445)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41b7c46d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_step_question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41b7c46d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_step_question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("0e587b8b", content, true, {});

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.step-question[data-v-41b7c46d]{padding:10px 125px 80px}@media(max-width:768px){.step-question[data-v-41b7c46d]{padding:30px 0 120px;width:auto}}.title-question[data-v-41b7c46d]{color:#02979b!important;font-family:Opens_bold;font-size:16px}.color-btn[data-v-41b7c46d]{color:#02979b!important;font-family:Opens_bold!important;background-color:#b0e0e6!important;font-size:14px!important;height:40px!important;width:130px!important}.btn-selected[data-v-41b7c46d]{border:1px solid #e0e5e8;border-radius:100%;-webkit-box-shadow:none!important;box-shadow:none!important;color:#02979b!important;font-family:Opens_semibold;font-size:18px;height:64px!important;width:64px!important}.btn-selected.active[data-v-41b7c46d]{background-color:#02979b!important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.15)!important;box-shadow:0 2px 4px 0 rgba(0,0,0,.15)!important;color:#fff!important;font-family:Opens_bold;letter-spacing:0}.message-box[data-v-41b7c46d]{background-color:#fff;-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.07);box-shadow:0 2px 6px 0 rgba(0,0,0,.07);border-radius:20px;border:5px solid #b0e0e6;font-family:Opens_bold;position:relative;width:100%;padding:30px 39px}.triangle[data-v-41b7c46d]{border-bottom:26px solid rgba(0,0,0,.05);border-left:8px solid transparent;border-right:8px solid transparent;position:absolute;right:117px;top:-26px;z-index:1}.triangle[data-v-41b7c46d]:before{border-bottom:25px solid #fff;border-left:7px solid transparent;border-right:7px solid transparent;bottom:-26px;content:\"\";left:-7px;position:absolute}.triangle.active-two[data-v-41b7c46d]{right:32px}.select[data-v-41b7c46d]{max-width:250px}.layout[data-v-41b7c46d]{position:relative}.title-integration[data-v-41b7c46d]{color:#494949;font-family:Opens_bold;font-size:16px}.description[data-v-41b7c46d]{color:#909090;font-family:Opens_regular;font-size:12px;width:390px}.video[data-v-41b7c46d]{height:202px;position:relative;overflow:hidden}.video[data-v-41b7c46d]:after{content:\"\";position:absolute;bottom:0;left:0;width:100%;height:70px;background:-webkit-gradient(linear,left bottom,left top,from(hsla(0,0%,100%,.9)),to(transparent));background:linear-gradient(0deg,hsla(0,0%,100%,.9),transparent);pointer-events:none}.img-source[data-v-41b7c46d]{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.title-warehouse[data-v-41b7c46d]{border-bottom:1px solid #d2d2d2;color:#494949;font-family:Opens_bold;font-size:16px;padding-bottom:9px}.dialog-contact[data-v-41b7c46d]{border-radius:11px;-webkit-box-shadow:0 2px 13px 0 rgba(0,0,0,.13);box-shadow:0 2px 13px 0 rgba(0,0,0,.13);padding:35px 55px 60px}.btn-contact[data-v-41b7c46d]{background-color:#4caf50;border-radius:5px;color:#fff;font-family:Opens_bold;font-size:14px;padding:9px}.btn-close[data-v-41b7c46d]{background-color:transparent!important;position:absolute!important;right:10px;top:10px}", "", {"version":3,"sources":["/opt/build/repo/src/components/accountant/step-question.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,gCAAgC,uBAAuB,CACtD,AACD,wBACA,gCAAgC,qBAAuB,UAAU,CAChE,CACA,AACD,iCAAiC,wBAAyB,uBAAyB,cAAc,CAChG,AACD,4BAA4B,wBAAyB,iCAAoC,mCAAoC,yBAA0B,sBAAuB,qBAAsB,CACnM,AACD,+BAA+B,yBAAyB,mBAAmB,kCAAmC,0BAA2B,wBAAyB,2BAA6B,eAAe,sBAAuB,oBAAqB,CACzP,AACD,sCAAsC,mCAAoC,yDAA0D,iDAAkD,qBAAsB,uBAAyB,gBAAkB,CACtP,AACD,8BAA8B,sBAAsB,+CAA+C,uCAAuC,mBAAmB,yBAAyB,uBAAyB,kBAAkB,WAAW,iBAAiB,CAC5P,AACD,2BAA2B,yCAAyC,kCAAoC,mCAAqC,kBAAkB,YAAY,UAAU,SAAS,CAC7L,AACD,kCAAkC,8BAA8B,kCAAoC,mCAAqC,aAAa,WAAW,UAAU,iBAAiB,CAC3L,AACD,sCAAsC,UAAU,CAC/C,AACD,yBAAyB,eAAe,CACvC,AACD,yBAAyB,iBAAiB,CACzC,AACD,oCAAoC,cAAc,uBAAyB,cAAc,CACxF,AACD,8BAA8B,cAAc,0BAA4B,eAAe,WAAW,CACjG,AACD,wBAAwB,aAAa,kBAAkB,eAAe,CACrE,AACD,8BAA+B,WAAW,kBAAkB,SAAS,OAAO,WAAW,YAAY,kGAA4G,gEAA0E,mBAAmB,CAC3S,AACD,6BAA6B,WAAW,YAAY,sBAAsB,kBAAkB,CAC3F,AACD,kCAAkC,gCAAgC,cAAc,uBAAyB,eAAe,kBAAkB,CACzI,AACD,iCAAiC,mBAAmB,gDAAgD,wCAAwC,sBAA2B,CACtK,AACD,8BAA8B,yBAAyB,kBAAkB,WAAW,uBAAyB,eAAe,WAAW,CACtI,AACD,4BAA4B,uCAA0C,4BAA6B,WAAW,QAAQ,CACrH","file":"step-question.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.step-question[data-v-41b7c46d]{padding:10px 125px 80px\n}\n@media(max-width: 768px){\n.step-question[data-v-41b7c46d]{padding:30px 0px 120px;width:auto\n}\n}\n.title-question[data-v-41b7c46d]{color:#02979b !important;font-family:\"Opens_bold\";font-size:16px\n}\n.color-btn[data-v-41b7c46d]{color:#02979b !important;font-family:\"Opens_bold\" !important;background-color:#b0e0e6 !important;font-size:14px !important;height:40px !important;width:130px !important\n}\n.btn-selected[data-v-41b7c46d]{border:1px solid #e0e5e8;border-radius:100%;-webkit-box-shadow:none !important;box-shadow:none !important;color:#02979b !important;font-family:\"Opens_semibold\";font-size:18px;height:64px !important;width:64px !important\n}\n.btn-selected.active[data-v-41b7c46d]{background-color:#02979b !important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.15) !important;box-shadow:0 2px 4px 0 rgba(0,0,0,.15) !important;color:#fff !important;font-family:\"Opens_bold\";letter-spacing:0px\n}\n.message-box[data-v-41b7c46d]{background-color:#fff;-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.07);box-shadow:0 2px 6px 0 rgba(0,0,0,.07);border-radius:20px;border:#b0e0e6 5px solid;font-family:\"Opens_bold\";position:relative;width:100%;padding:30px 39px\n}\n.triangle[data-v-41b7c46d]{border-bottom:26px solid rgba(0,0,0,.05);border-left:8px solid rgba(0,0,0,0);border-right:8px solid rgba(0,0,0,0);position:absolute;right:117px;top:-26px;z-index:1\n}\n.triangle[data-v-41b7c46d]:before{border-bottom:25px solid #fff;border-left:7px solid rgba(0,0,0,0);border-right:7px solid rgba(0,0,0,0);bottom:-26px;content:\"\";left:-7px;position:absolute\n}\n.triangle.active-two[data-v-41b7c46d]{right:32px\n}\n.select[data-v-41b7c46d]{max-width:250px\n}\n.layout[data-v-41b7c46d]{position:relative\n}\n.title-integration[data-v-41b7c46d]{color:#494949;font-family:\"Opens_bold\";font-size:16px\n}\n.description[data-v-41b7c46d]{color:#909090;font-family:\"Opens_regular\";font-size:12px;width:390px\n}\n.video[data-v-41b7c46d]{height:202px;position:relative;overflow:hidden\n}\n.video[data-v-41b7c46d]::after{content:\"\";position:absolute;bottom:0;left:0;width:100%;height:70px;background:-webkit-gradient(linear, left bottom, left top, from(rgba(255, 255, 255, 0.9)), to(transparent));background:linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);pointer-events:none\n}\n.img-source[data-v-41b7c46d]{width:100%;height:100%;-o-object-fit:contain;object-fit:contain\n}\n.title-warehouse[data-v-41b7c46d]{border-bottom:1px solid #d2d2d2;color:#494949;font-family:\"Opens_bold\";font-size:16px;padding-bottom:9px\n}\n.dialog-contact[data-v-41b7c46d]{border-radius:11px;-webkit-box-shadow:0 2px 13px 0 rgba(0,0,0,.13);box-shadow:0 2px 13px 0 rgba(0,0,0,.13);padding:35px 55px 60px 55px\n}\n.btn-contact[data-v-41b7c46d]{background-color:#4caf50;border-radius:5px;color:#fff;font-family:\"Opens_bold\";font-size:14px;padding:9px\n}\n.btn-close[data-v-41b7c46d]{background-color:rgba(0,0,0,0) !important;position:absolute !important;right:10px;top:10px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-question"},[_c('v-flex',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{staticClass:"title-question",attrs:{"xs6":"","lg4":"","ml-3":"","text-xs-left":""}},[_c('p',{staticClass:"ma-0",domProps:{"innerHTML":_vm._s(_vm.question)}})]),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('v-btn',{staticClass:"btn-auto btn-selected",class:{'active' : _vm.showOne },attrs:{"type":"button"},on:{"click":function($event){return _vm.open('showOne', 'showTwo')}}},[_vm._v("\n\t\t\t\t\t?\n\t\t\t\t")])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"layout",attrs:{"mt-4":""}},[_c('div',{staticClass:"triangle",class:{ 'active-two' : _vm.showTwo }}),_vm._v(" "),_c('v-flex',{staticClass:"message-box",attrs:{"xs12":""}},[(_vm.showOne)?_c('v-flex',[_c('v-layout',{attrs:{"row":"","justify-space-between":"","align-center":""}},[_c('v-flex',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"title-integration"},[_c('p',{staticClass:"ma-0",domProps:{"innerHTML":_vm._s(_vm.acceptTitle)}})]),_vm._v(" "),_c('v-flex',{staticClass:"description",attrs:{"mt-3":""}},[_c('p',{staticClass:"ma-0",domProps:{"innerHTML":_vm._s(_vm.acceptDescription)}})])],1)],1),_vm._v(" "),_c('v-flex',[_c('v-flex',{staticClass:"video"},[_c('img',{staticClass:"img-source",attrs:{"src":'/static/img/imgconta2.jpeg',"alt":"img-conta"}})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"mt-3":""}},[_c('v-flex',{staticClass:"title-warehouse",attrs:{"xs12":"","mb-3":""}},[_vm._v("\n\t\t\t\t\t\t\tSeleccionar una empresa\n\t\t\t\t\t\t")]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('HeaderSelect',{staticClass:"select",attrs:{"return-object":"","placeholder":"Seleccione una empresa","item-text":"name","item-value":"id","disabled":_vm.$route.meta.noChangeCompany,"height":33,"items":_vm.getGlobalSubsidiaries,"value":_vm.currentSubsidiary.id},on:{"input":_vm.$setCurrentSubsidiary}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showTwo)?_c('v-flex',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.negativeTitle)+"\n\t\t\t\t")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"470"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('v-card',{staticClass:"dialog-contact"},[_c('v-btn',{staticClass:"btn-close btn-auto",attrs:{"depressed":"","small":""},on:{"click":function($event){return _vm.$emit('close-dialog')}}},[_c('span',{staticClass:"error--text"},[_vm._v("x")])]),_vm._v(" "),_c('v-flex',{staticClass:"title-question",attrs:{"mt-3":"","text-xs-center":""}},[_vm._v("\n\t\t\t\tPara integrarte con quipu debes ir a la configuración de\n\t\t\t")])],1)],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('v-btn',{staticClass:"color-btn",attrs:{"color":"btnFollowing","type":"button","disabled":_vm.disabledQuestion},nativeOn:{"click":function($event){return _vm.$emit('following-question')}}},[_vm._v("\n\t\t\t\tSiguiente\n\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('app-actions',{attrs:{"resource-uri":_vm.$route.name},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-stepper',{staticClass:"accountant-steps",attrs:{"non-linear":""},model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-header',[_c('div',{staticClass:"stepper-header-container stepper__header justify-center"},[_c('v-stepper-step',{attrs:{"step":1,"complete":_vm.step > 1,"color":"#02979b"}},[_vm._v("Principal")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":2,"complete":_vm.step > 2}},[_vm._v("Estadisticas")])],1)]),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('step-question',{attrs:{"open-dialog":_vm.openDialog},on:{"following-question":_vm.followingQuestion}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_main_vue__ = __webpack_require__(1178);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4223af12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_main_vue__ = __webpack_require__(1451);
function injectStyle (ssrContext) {
  __webpack_require__(1442)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4223af12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4223af12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_accounting_utils_help_component__ = __webpack_require__(827);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var appCode, uri, params, headers, _ref2, actions;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						appCode = 'quipu-admin';
						uri = this.resourceUri;
						params = {
							languages: 'es'
						};
						headers = {
							Accept: 'application/vnd.apiacl.v2+json'
						};
						_context.prev = 4;
						_context.next = 7;
						return this.$httpAcl.get('sidebar/' + appCode + '/resource/' + uri, { params: params, headers: headers });

					case 7:
						_ref2 = _context.sent;
						actions = _ref2.data;

						this.actions = actions.data.map(function (actionSingle) {
							var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, actionSingle);
							var index = _this.valueDisabled.findIndex(function (val) {
								return val.code === actionSingle.code;
							});
							newAction.name = actionSingle.languages;
							newAction.disabled = index > -1 && _this.valueDisabled[index].disabled;
							return newAction;
						});
						this.newActions = this.actions.splice(0, 3);
						this.actionComplete = actions.data;
						_context.next = 17;
						break;

					case 14:
						_context.prev = 14;
						_context.t0 = _context['catch'](4);

						this.showNotification('Recursos cargados', 'success');

					case 17:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[4, 14]]);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function created() {
	this.loadData();
}

function actionDisabled(values) {
	this.actions = this.actions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		newAction.showMessage = index > -1 ? values[index].showMessage || false : false;
		newAction.message = index > -1 ? values[index].message : null;
		accum.push(newAction);
		return accum;
	}, []);
	this.newActions = this.newActions.reduce(function (accum, act) {
		var newAction = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, act);
		var index = values.findIndex(function (v) {
			return v.code === act.code;
		});
		newAction.disabled = index > -1 && values[index].disabled;
		newAction.showMessage = index > -1 ? values[index].showMessage || false : false;
		newAction.message = index > -1 ? values[index].message : null;
		accum.push(newAction);
		return accum;
	}, []);
}

function openAction(item) {
	if (!item.disabled) {
		if (item.code === 'HELP') {
			var helpIndex = this.actions.findIndex(function (act) {
				return act.code === item.code;
			});
			var newActions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.actions);
			newActions.splice(helpIndex, 1);
			var model = {
				code: item.code,
				actions: newActions
			};
			this.$emit('open-help', model);
		} else {
			this.$emit('run-action', item);
		}
	}
}

function openHelp() {
	this.action = {
		title: this.$route.meta.title,
		code: 'H',
		open: true,
		value: true,
		width: 500
	};
	this.helps = this.actionComplete;
}

function cancelModal() {
	this.action = {
		value: false,
		code: null,
		title: ''
	};
}

function openActionVertical() {
	this.showActionVertical = !this.showActionVertical;
}

function watchRoute(routeValue) {
	if (routeValue) {
		this.loadData();
	}
}

function data() {
	return {
		actions: [],
		helps: [],
		actionComplete: [],
		newActions: [],
		action: {
			value: false,
			code: '',
			open: false,
			title: '',
			width: 600
		},
		showActionVertical: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app-actions',
	created: created,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["a" /* default */],
		helpComponent: __WEBPACK_IMPORTED_MODULE_5__components_accounting_utils_help_component__["a" /* default */]
	},
	methods: {
		cancelModal: cancelModal,
		loadData: loadData,
		openAction: openAction,
		openHelp: openHelp,
		openActionVertical: openActionVertical
	},
	data: data,
	props: {
		resourceUri: {
			required: true,
			type: String
		},
		valueDisabled: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	},
	watch: {
		valueDisabled: {
			deep: true,
			handler: actionDisabled
		},
		$route: watchRoute
	}
});

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'help-component',
	props: {
		helps: {
			type: Array,
			default: function _default() {
				return [];
			},
			required: true
		}
	}
});

/***/ }),

/***/ 824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_actions_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71471f8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_actions_vue__ = __webpack_require__(831);
function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71471f8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71471f8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("4889eef0", content, true, {});

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.name-action[data-v-71471f8b]{color:#e0e5e8!important;font-family:Opens_semibold;font-size:13px}.btn-add-actions[data-v-71471f8b]{border:1px solid;border-radius:50%;height:25px;margin-left:14px;width:25px}.add-icon[data-v-71471f8b]{position:relative;top:3px}@media(max-width:760px){.app-actions[data-v-71471f8b]{display:none}}.border[data-v-71471f8b]{border:1px solid;height:15px;margin:0 0 0 15px}.width-content[data-v-71471f8b]{margin:0 0 0 auto;width:89%}.btn-add[data-v-71471f8b]{height:25px;width:24px}.btn-app-actions[data-v-71471f8b]{background-color:#fff;border:1px solid #02979b!important;border-radius:5px;-webkit-box-shadow:none;box-shadow:none;color:#02979b;font-family:Opens_semibold;font-size:12px;margin:6px;position:relative;text-transform:uppercase;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;width:160px}.btn-app-actions.disabled[data-v-71471f8b]{border:1px solid #c8c8c8!important;color:#c8c8c8!important;cursor:not-allowed}.btn-app-actions[data-v-71471f8b]:not(.disabled):hover{background-color:#02979b;color:#fff}.btn-app-actions:not(.disabled):hover .content-images-action .img-resource[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)}.message-action[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);display:none;font-size:12px;left:-95px;padding:15px;position:absolute;text-transform:none;top:51px;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;z-index:2;width:109%}.message-action[data-v-71471f8b]:before{background:#fff;border:1px solid;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:60%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.bold[data-v-71471f8b]{font-family:Opens_semibold}.message-action-list[data-v-71471f8b]{font-size:12px;position:absolute}.img-resource[data-v-71471f8b]{-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s}.img-resource.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.content-images-action.show-description:hover .img-resource-help[data-v-71471f8b],.content-images-action.show-description:hover .message-action[data-v-71471f8b]{display:block}.content-images-action.show-description:hover .img-resource[data-v-71471f8b]{display:none}.img-gray[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.img-white[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)}.img-resource-help[data-v-71471f8b]{display:none}.content-action-vertical[data-v-71471f8b]{position:relative}.content-list-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid #ebebeb;border-radius:5px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.05);box-shadow:0 2px 5px 0 rgba(0,0,0,.05);left:-135%;padding:6px;position:absolute;top:41px;width:197px;z-index:4}.content-list-action-vertical.open-action[data-v-71471f8b]{display:block}.content-list-action-vertical.close-action[data-v-71471f8b]{display:none}.content-list-action-vertical[data-v-71471f8b]:before{background:#fff;border:1px solid #ebebeb;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:41%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.content-btn-vertical[data-v-71471f8b]{padding:8px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.content-btn-vertical-text[data-v-71471f8b]{color:#e0e5e8;font-size:12px;text-align:left;text-transform:uppercase}.content-btn-vertical-text.disabled[data-v-71471f8b]{color:#c8c8c8}.content-btn-vertical.disabled[data-v-71471f8b]{cursor:not-allowed}.img-veritical.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)}.content-image-message[data-v-71471f8b]{position:relative}.content-image-message:hover .message-action-vertical[data-v-71471f8b]{display:block}.content-image-message:hover .img-veritical[data-v-71471f8b]{display:none}.content-image-message:hover .img-resource-help-vertical[data-v-71471f8b]{display:block}.message-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);box-shadow:0 2px 4px 0 hsla(0,0%,62%,.5);font-size:12px;display:none;padding:6px;position:absolute;right:29px;top:-14px;width:178px}.message-action-vertical[data-v-71471f8b]:before{background:#fff;border:1px solid;border-bottom-width:0;border-left-width:0;content:\"\";height:15px;position:absolute;right:-8px;top:11px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.img-resource-help-vertical[data-v-71471f8b]{display:none;height:24px}.new-indicator[data-v-71471f8b]{right:1px;position:absolute;top:.5px}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/app-actions/app-actions.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,8BAA8B,wBAAyB,2BAA6B,cAAc,CACjG,AACD,kCAAkC,iBAAiB,kBAAkB,YAAY,iBAAiB,UAAU,CAC3G,AACD,2BAA2B,kBAAkB,OAAO,CACnD,AACD,wBACA,8BAA8B,YAAY,CACzC,CACA,AACD,yBAAyB,iBAAiB,YAAY,iBAAiB,CACtE,AACD,gCAAgC,kBAAkB,SAAS,CAC1D,AACD,0BAA0B,YAAY,UAAU,CAC/C,AACD,kCAAkC,sBAAsB,mCAAoC,kBAAkB,wBAAwB,gBAAgB,cAAc,2BAA6B,eAAe,WAAW,kBAAkB,yBAAyB,0CAA0C,kCAAkC,WAAW,CAC5V,AACD,2CAA2C,mCAAoC,wBAAyB,kBAAkB,CACzH,AACD,uDAAuD,yBAAyB,UAAU,CACzF,AACD,4FAA4F,+BAA+B,uCAAuC,mCAAmC,CACpM,AACD,iCAAiC,sBAAsB,iBAAiB,kBAAkB,iDAAoD,yCAA4C,aAAa,eAAe,WAAW,aAAa,kBAAkB,oBAAoB,SAAS,0CAA0C,kCAAkC,UAAU,UAAU,CAC5X,AACD,wCAAyC,gBAAgB,iBAAiB,sBAAsB,qBAAqB,WAAW,YAAY,SAAS,kBAAkB,SAAS,WAAW,gCAAgC,uBAAuB,CACjP,AACD,uBAAuB,0BAA4B,CAClD,AACD,sCAAsC,eAAe,iBAAiB,CACrE,AACD,+BAA+B,0CAA0C,iCAAiC,CACzG,AACD,wCAAwC,uBAAuB,+BAA+B,2BAA2B,CACxH,AAGD,iKAAkF,aAAa,CAC9F,AACD,6EAA6E,YAAY,CACxF,AACD,2BAA2B,uBAAuB,+BAA+B,2BAA2B,CAC3G,AACD,4BAA4B,+BAA+B,uCAAuC,mCAAmC,CACpI,AACD,oCAAoC,YAAY,CAC/C,AACD,0CAA0C,iBAAiB,CAC1D,AACD,+CAA+C,sBAAsB,yBAAyB,kBAAkB,+CAA+C,uCAAuC,WAAW,YAAY,kBAAkB,SAAS,YAAY,SAAS,CAC5Q,AACD,2DAA2D,aAAa,CACvE,AACD,4DAA4D,YAAY,CACvE,AACD,sDAAuD,gBAAgB,yBAAyB,sBAAsB,qBAAqB,WAAW,YAAY,SAAS,kBAAkB,SAAS,WAAW,gCAAgC,uBAAuB,CACvQ,AACD,uCAAuC,cAAc,oBAAoB,oBAAoB,YAAY,CACxG,AACD,4CAA4C,cAAc,eAAe,gBAAgB,wBAAwB,CAChH,AACD,qDAAqD,aAAa,CACjE,AACD,gDAAgD,kBAAkB,CACjE,AACD,yCAAyC,uBAAuB,+BAA+B,2BAA2B,CACzH,AACD,wCAAwC,iBAAiB,CACxD,AACD,uEAAuE,aAAa,CACnF,AACD,6DAA6D,YAAY,CACxE,AACD,0EAA0E,aAAa,CACtF,AACD,0CAA0C,sBAAsB,iBAAiB,kBAAkB,iDAAoD,yCAA4C,eAAe,aAAa,YAAY,kBAAkB,WAAW,UAAU,WAAW,CAC5R,AACD,iDAAkD,gBAAgB,iBAAiB,sBAAsB,oBAAoB,WAAW,YAAY,kBAAkB,WAAW,SAAS,WAAW,gCAAgC,uBAAuB,CAC3P,AACD,6CAA6C,aAAa,WAAW,CACpE,AACD,gCAAgC,UAAU,kBAAkB,QAAQ,CACnE","file":"app-actions.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.name-action[data-v-71471f8b]{color:#e0e5e8 !important;font-family:\"Opens_semibold\";font-size:13px\n}\n.btn-add-actions[data-v-71471f8b]{border:solid 1px;border-radius:50%;height:25px;margin-left:14px;width:25px\n}\n.add-icon[data-v-71471f8b]{position:relative;top:3px\n}\n@media(max-width: 760px){\n.app-actions[data-v-71471f8b]{display:none\n}\n}\n.border[data-v-71471f8b]{border:1px solid;height:15px;margin:0 0 0 15px\n}\n.width-content[data-v-71471f8b]{margin:0 0 0 auto;width:89%\n}\n.btn-add[data-v-71471f8b]{height:25px;width:24px\n}\n.btn-app-actions[data-v-71471f8b]{background-color:#fff;border:1px solid #02979b !important;border-radius:5px;-webkit-box-shadow:none;box-shadow:none;color:#02979b;font-family:\"Opens_semibold\";font-size:12px;margin:6px;position:relative;text-transform:uppercase;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;width:160px\n}\n.btn-app-actions.disabled[data-v-71471f8b]{border:1px solid #c8c8c8 !important;color:#c8c8c8 !important;cursor:not-allowed\n}\n.btn-app-actions[data-v-71471f8b]:not(.disabled):hover{background-color:#02979b;color:#fff\n}\n.btn-app-actions:not(.disabled):hover .content-images-action .img-resource[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)\n}\n.message-action[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(157,157,157,.5);box-shadow:0 2px 4px 0 rgba(157,157,157,.5);display:none;font-size:12px;left:-95px;padding:15px;position:absolute;text-transform:none;top:51px;-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s;z-index:2;width:109%\n}\n.message-action[data-v-71471f8b]::before{background:#fff;border:1px solid;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:60%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.bold[data-v-71471f8b]{font-family:\"Opens_semibold\"\n}\n.message-action-list[data-v-71471f8b]{font-size:12px;position:absolute\n}\n.img-resource[data-v-71471f8b]{-webkit-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s\n}\n.img-resource.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.content-images-action.show-description:hover .message-action[data-v-71471f8b]{display:block\n}\n.content-images-action.show-description:hover .img-resource-help[data-v-71471f8b]{display:block\n}\n.content-images-action.show-description:hover .img-resource[data-v-71471f8b]{display:none\n}\n.img-gray[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.img-white[data-v-71471f8b]{filter:brightness(0) invert(1);-webkit-filter:brightness(0) invert(1);-moz-filter:brightness(0) invert(1)\n}\n.img-resource-help[data-v-71471f8b]{display:none\n}\n.content-action-vertical[data-v-71471f8b]{position:relative\n}\n.content-list-action-vertical[data-v-71471f8b]{background-color:#fff;border:solid 1px #ebebeb;border-radius:5px;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.05);box-shadow:0 2px 5px 0 rgba(0,0,0,.05);left:-135%;padding:6px;position:absolute;top:41px;width:197px;z-index:4\n}\n.content-list-action-vertical.open-action[data-v-71471f8b]{display:block\n}\n.content-list-action-vertical.close-action[data-v-71471f8b]{display:none\n}\n.content-list-action-vertical[data-v-71471f8b]::before{background:#fff;border:1px solid #ebebeb;border-bottom-width:0;border-right-width:0;content:\"\";height:15px;left:41%;position:absolute;top:-9px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.content-btn-vertical[data-v-71471f8b]{padding:8px 0;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.content-btn-vertical-text[data-v-71471f8b]{color:#e0e5e8;font-size:12px;text-align:left;text-transform:uppercase\n}\n.content-btn-vertical-text.disabled[data-v-71471f8b]{color:#c8c8c8\n}\n.content-btn-vertical.disabled[data-v-71471f8b]{cursor:not-allowed\n}\n.img-veritical.disabled[data-v-71471f8b]{filter:grayscale(100%);-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%)\n}\n.content-image-message[data-v-71471f8b]{position:relative\n}\n.content-image-message:hover .message-action-vertical[data-v-71471f8b]{display:block\n}\n.content-image-message:hover .img-veritical[data-v-71471f8b]{display:none\n}\n.content-image-message:hover .img-resource-help-vertical[data-v-71471f8b]{display:block\n}\n.message-action-vertical[data-v-71471f8b]{background-color:#fff;border:1px solid;border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(157,157,157,.5);box-shadow:0 2px 4px 0 rgba(157,157,157,.5);font-size:12px;display:none;padding:6px;position:absolute;right:29px;top:-14px;width:178px\n}\n.message-action-vertical[data-v-71471f8b]::before{background:#fff;border:1px solid;border-bottom-width:0;border-left-width:0;content:\"\";height:15px;position:absolute;right:-8px;top:11px;width:15px;-webkit-transform:rotate(45deg);transform:rotate(45deg)\n}\n.img-resource-help-vertical[data-v-71471f8b]{display:none;height:24px\n}\n.new-indicator[data-v-71471f8b]{right:1px;position:absolute;top:.5px\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_component_vue__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c459fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_component_vue__ = __webpack_require__(830);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c459fd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c459fd2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(829);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("7dbef01e", content, true, {});

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.help[data-v-6c459fd2]{font-size:14px}.article[data-v-6c459fd2]{margin:20px 0}.article-title[data-v-6c459fd2]{border-bottom:1px solid #fafcff;padding-bottom:8px}.article-description[data-v-6c459fd2]{margin:25px 0 10px}.list-none[data-v-6c459fd2]{list-style:none!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/accounting/utils/help-component.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,uBAAuB,cAAc,CACpC,AACD,0BAA0B,aAAa,CACtC,AACD,gCAAgC,gCAAgC,kBAAkB,CACjF,AACD,sCAAsC,kBAAkB,CACvD,AACD,4BAA4B,yBAA0B,CACrD","file":"help-component.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.help[data-v-6c459fd2]{font-size:14px\n}\n.article[data-v-6c459fd2]{margin:20px 0\n}\n.article-title[data-v-6c459fd2]{border-bottom:1px solid #fafcff;padding-bottom:8px\n}\n.article-description[data-v-6c459fd2]{margin:25px 0 10px\n}\n.list-none[data-v-6c459fd2]{list-style:none !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"help",attrs:{"row":"","mt-4":"","d-flex":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},_vm._l((_vm.helps),function(help,indexH){return _c('article',{key:indexH,staticClass:"article mb-3"},[_c('v-layout',{staticClass:"article-title",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('img',{attrs:{"src":help.pathIcon,"alt":help.languages}})]),_vm._v(" "),_c('v-flex',[_c('h3',[_vm._v(_vm._s(help.languages))])])],1),_vm._v(" "),_c('section',{staticClass:"article-description"},[_c('h4',{staticClass:"article-description_title"},[_vm._v("Descripción")]),_vm._v(" "),_c('p',{staticClass:"article-description_content"},[_vm._v(_vm._s(help.description))])]),_vm._v(" "),_c('span',[_c('h4',{staticClass:"article-description_title"},[_vm._v("Tutorial:")]),_vm._v(" "),_c('a',{attrs:{"href":help.link,"target":"_blank"}},[_vm._v(_vm._s(help.link))])]),_vm._v(" "),_c('h4',{staticClass:"article-description_title mt-2"},[_vm._v("Manuales:")]),_vm._v(" "),_c('ul',{staticClass:"list-none"},_vm._l((help.manuals),function(man,index){return _c('li',{key:index},[_c('a',{attrs:{"href":man.file,"target":"_blank"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(man.file)+"\n\t\t\t\t\t")])])}),0)],1)}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"app-actions",attrs:{"justify-end":""}},[_c('v-layout',[_c('v-flex',[(this.actionComplete.length > 0)?_c('v-layout',{staticClass:"px-5 width-content",attrs:{"row":"","align-center":"","justify-end":""}},[_vm._l((_vm.newActions),function(item,index){return _c('div',{key:index,staticClass:"border-right"},[_c('button',{staticClass:"btn-app-actions",class:{ 'disabled': item.disabled },attrs:{"type":"button","color":"white"},on:{"click":function($event){return _vm.openAction(item)}}},[_c('v-layout',[_c('v-flex',{staticClass:"content-images-action",class:{'show-description': item.description.length > 0},attrs:{"xs2":"","py-2":"","pl-2":""}},[(item.pathIcon)?_c('img',{staticClass:"img-resource mr-2",class:{ 'disabled': item.disabled },attrs:{"src":item.pathIcon,"alt":item.name,"height":"16","width":"13"}}):_vm._e(),_vm._v(" "),(item.description.length > 0)?_c('img',{staticClass:"img-resource-help",class:[item.disabled ? 'img-gray' : 'img-white'],attrs:{"src":"/static/img/help-action.svg","alt":"ayuda","height":"15"}}):_vm._e(),_vm._v(" "),(item.description.length > 0)?_c('div',{staticClass:"message-action"},[_c('p',{staticClass:"mb-1 primary--text bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(item.description))])]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","py-2":"","pr-2":""}},[(item.flagNew)?_c('app-tooltip-button',{staticClass:"new-indicator",attrs:{"color":"info","height":"10","icon":"fiber_manual_record","text":item.newTitle || 'Nuevo'}}):_vm._e(),_vm._v(" "),(item.name.length > 14)?_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm._f("limitTo")(item.name,14)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]):_c('span',[_vm._v(_vm._s(item.name))])],1)],1)],1)])}),_vm._v(" "),(this.actions.length > 0)?_c('div',{staticClass:"content-action-vertical"},[_c('v-btn',{staticClass:"btn-help",attrs:{"color":"primary","fab":"","small":""},on:{"click":_vm.openActionVertical}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-icon',{staticClass:"add-icon",attrs:{"slot":"activator","color":"white"},slot:"activator"},[_vm._v("add")]),_vm._v(" "),_c('span',[_vm._v("Mas opciones")])],1)],1),_vm._v(" "),_c('div',{staticClass:"content-list-action-vertical",class:[_vm.showActionVertical ? 'open-action' : 'close-action']},_vm._l((_vm.actions),function(item,index){return _c('div',{key:index},[_c('button',{staticClass:"content-btn-vertical",class:{'disabled': item.disabled},on:{"click":function($event){return _vm.openAction(item)}}},[_c('div',{staticClass:"mr-2 content-image-message"},[_c('div',[(item.pathIcon)?_c('img',{staticClass:"img-veritical",class:{'disabled': item.disabled},attrs:{"src":item.pathIcon,"alt":item.name,"height":"16","width":"13"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-resource-help-vertical",class:{'img-gray': item.disabled},attrs:{"src":"/static/img/help-action.svg","alt":"ayuda","height":"16","width":"13"}})]),_vm._v(" "),(item.description.length > 0)?_c('div',{staticClass:"message-action-vertical"},[_c('p',{staticClass:"mb-1 primary--text bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(item.description))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content-btn-vertical-text",class:{'disabled': item.disabled}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t\t")])])])}),0)],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"btn-help",attrs:{"color":"success","fab":"","small":""},on:{"click":_vm.openHelp}},[_c('img',{attrs:{"src":"/static/icon/btn-help-center.svg"}})])],2):_vm._e()],1)],1),_vm._v(" "),_c('action-sidebar',{attrs:{"help-actions":_vm.newActions,"title":_vm.action.title,"value":_vm.action.value,"width":_vm.action.width},on:{"close-modal":_vm.cancelModal}},[_c('help-component',{attrs:{"helps":_vm.helps}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/40.23169de7406b1d40aaae.js